import { request } from '@/util/http'

// export const getList = (current, size, params) => {
//   return request({
//     url: '/health/bsmeterdataitem/getList',
//     method: 'get',
//     params: {
//       ...params,
//       current,
//       size
//     }
//   })
// }

export const getList = (current, size, params) => {
  return request({
    url: '/health/btmeterdata/getList',
    method: 'get',
    params: {
      ...params,
      current,
      size
    }
  })
}

export const submitForm = (row) => {
  return request({
    url: '/health/btmeterdata/submitFormBt',
    method: 'post',
    data: row
  })
}

export const btZcReport = (row) => {
  return request({
    url: '/health/btmeterdata/btZcReport',
    method: 'post',
    data: row
  })
}

